module.exports = function() {
  return new Worker(__webpack_public_path__ + "e1a09ed4e0ae16ff882a.worker.js");
};